import { Component, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';

/**
 * Conjunt de botons que ofereixen diferents funcionalitats a l'aplicació, com canviar el tipus de mapa,
 * imprimir una imatge d'aquest, compartir la pàgina, enviar feedback o canviar d'idioma
 */
@Component({
  selector: 'app-botons',
  templateUrl: './botons.component.html',
  styleUrls: ['./botons.component.css']
})
export class BotonsComponent implements OnInit {

  /**
   * Constructor del component
   * @param dialog {MatDialog} finestra per obrir i donar opcions per compartir
   * @param localeId {string} idioma actual de la pàgina
   */
  constructor(public dialog: MatDialog, @Inject(LOCALE_ID) protected localeId: string) { }

  /**
   * El mapa amb el que poden interactuar els botons
   */
  @Input() map : google.maps.Map; 

  /**
   * Tipus de mapa seleccionat
   */
  selectedLayer : string = "racc"; 

  /**
   * idioma seleccionat
   */
  selectedLanguage : string = this.localeId;

  /**
   * Pel mode mòbil, indica si es volen mostrar els botons o no
   */
  mostrarBotons: boolean = false; 

  /**
   * Donat un identificador de tipus de mapa, canvia l'aparença del mapa pel tipus seleccionat
   */
  changeMapType(): void {
    console.log(this.map.getMapTypeId());
    this.map.setMapTypeId(this.selectedLayer);
    console.log(this.map.getMapTypeId());
  }

  /**
   * Imprimeix el mapa
   */
  print(): void{
    window.print();
  }

  /**
   * Activa o desactiva els botons
   */
  toggleButtons(): void{
    this.mostrarBotons = !this.mostrarBotons;
  }

  /**
   * Obre la finestra per mostrar les opcions de compartir la pàgina
   */
  openShareDialog(): void{
    const dialogRef = this.dialog.open(ShareDialogComponent,
      {
        autoFocus: false,
        width: '50%',
        height: '50%',
        maxWidth: '100vw',
        maxHeight: '100vh',
        
      }
    );

  }

  
  /**
   * Inicialitza el component
   */
  ngOnInit() {
  }

}
